export enum SERVICE_METHODS {
  GET = "GET",
  GET_CONFIG = "GET_CONFIG",
  POST = "POST",
  POST_CONFIG = "POST_CONFIG",
  PUT = "PUT",
  PUT_CONFIG = "PUT_CONFIG",
  DELETE = "DELETE",
  DELETE_CONFIG = "DELETE_CONFIG",
  REQUEST = "REQUEST",
}

export enum LOGIN_CLIENT_TYPE {
  Pwa = "pwa",
  Native = "native",
  Admin = "admin",
  Unknown = "unknown",
}

export enum LOGOUT_REASON_ENUM {
  Manual = "manual",
  IdleTimeout = "idle_timeout",
  SessionExpired = "session_expired",
}

export enum LOCAL_STORAGE_KEYS {
  UserInfo = "UserInfo",
  ProfileName = "ProfileName",
  ProfileUrl = "ProfileUrl",
}

export enum AUTH_TOKEN_MESSAGE_TYPE_ENUM {
  TokenRequest = "token.request",
  Token = "token",
  SessionEnded = "session.ended",
}

export enum DATE_FORMAT {
  "DD-Mon-YYYY" = 1, // 01-Mar-2023
  "DD-MM-YYYY" = 2, // 01-03-2023
  "YYYY-MM-DD" = 3, // 2023-01-03
  "MM-DD-YYYY" = 4,
}

export enum THEMES {
  Light = "Light",
  Dark = "Dark",
  Cold = "Cold",
  Winter = "Winter",
}

export enum USER_STATUS {
  Trainer = 2,
  Admin = 1,
  User = 3,
}

export enum BIT_VALUE {
  One = "1",
  Zero = "0",
}

export enum ALERT_TYPE {
  Success = "success",
  Error = "error",
}

export const enum CONTROL_TYPE {
  TextInput = 1,
  NumberInput = 2,
  Switch = 3,
  PasswordInput = 4,
  TextArea = 5,
  Editor = 6,
  ColorPiker = 7,
}

export enum SYSTEM_CONFIGURATION_TABS {
  SystemSettings = 1,
  ContentManagement = 2,
  EmailTemplate = 3,
  SmsTemplate = 4,
}

export enum SYSTEM_CONFIGURATION_KEYS {
  SystemIdelTimeout = "session_idle_timeout",
  SystemIdelTimeoutAlert = "idle_timeout_alert",
}

export enum LOOKUP_CATEGORY {
  FirmType = "firm_type",
  MeasurementUnit = "measurement_unit",
  Gender = "gender",
  DateFormat = "date_format",
  TimeFormat = "time_format",
  ExpenseHead = "expense_head",
}

export enum IMAGE_TYPE {
  GalleryFolder = "1",
  GalleryItem = "2",
  MeasurementType = "3",
  measurementField = "6",
  Expense = "7",
}

export enum ENTITY_TYPE {
  HelpTopic = "12",
}

// Role ids are uuid (Task 1707). Fixed deterministic UUID constants — verbatim from
// Tasks/1707-int-bigint-to-uuidv7/04-id-contract.md (DB-verified; do NOT alter a digit).
export enum STATIC_ROLE {
  SuperAdmin = "01910000-0000-7000-8000-000000000001",
  FirmOwner = "01910000-0000-7000-8000-000000000002",
  BranchOwner = "01910000-0000-7000-8000-000000000003",
  Tailor = "01910000-0000-7000-8000-000000000004",
}

export enum AUDIT_LOG_TYPE {
  HsnCode = "HsnCode",
  ClaimGroup = "ClaimGroup",
  Role = "Role",
  Firm = "Firm",
  SubscriptionPackage = "SubscriptionPackage",
  CreditPlan = "CreditPlan",
}

export enum AUDIT_ACTION {
  Create = "create",
  Update = "update",
  Delete = "delete",
  Restore = "restore",
}

export enum BROWSER_NAME {
  Firefox = "Firefox",
  Chrome = "Chrome",
  Safari = "Safari",
  Edge = "Edge",
  Opera = "Opera",
  IE = "Internet Explorer",
  Samsung = "Samsung Internet",
  Brave = "Brave",
  Unknown = "Unknown",
}

export enum OS_NAME {
  Unknown = "Unknown OS",
  Windows = "Windows",
  MacOS = "MacOS",
  Linux = "Linux",
  Android = "Android",
  IOS = "iOS",
}

export enum DEVICE_NAME {
  Mobile = "Mobile",
  Tablet = "Tablet",
  Desktop = "Desktop",
}

export enum ADDRESS_STATUS {
  Pending = "pending",
  Verified = "verified",
  Rejected = "rejected",
}

export enum FILE_TYPE {
  Jpg = "jpg",
  Jpeg = "jpeg",
  Png = "png",
  Pdf = "pdf",
}

export enum ASSIGN_TYPE {
  Yes = "Yes",
  No = "No",
}

export enum STATE_TYPE {
  Company = "company",
  Other = "other",
  CompanyState = "company_state",
  OtherState = "other_state",
}

export enum PAYMENT_METHOD {
  Cash = "cash",
  Card = "card",
  Cheque = "cheque",
}

export enum UPLOAD_DOCUMENT_TYPE {
  Pdf = "pdf",
  Image = "image",
  Video = "video",
}

export enum TAX_STATE {
  CompanyState = "company_state",
  OtherState = "other_state",
}

export enum SYSTEM_TAX_CATEGORY_ENUM {
  SGST = "SGST",
  IGST = "IGST",
  CGST = "CGST",
}

export enum SUBMIT_LOGIN_SESSION_SELECT {
  Success = "success",
  Retry = "retry",
  Expired = "expired",
}
export enum EDITOR_MODE {
  Rich = "rich",
  Html = "html",
}
export enum HTML_FONT_WEIGHT_ENUM {
  Bold = "bold",
  Bolder = "bolder",
  Normal = "normal",
  Style = "style",
  Initial = "initial",
}
